// export function globParamSuccess(params) {
//   return {
//     type: '@param/GLOB_PARAM_SUCCESS',
//     payload: { params },
//   };
// }

// export function globParamFailure() {
//   return {
//     type: '@param/GLOB_PARAM_FAILURE',
//   };
// }

// export function setSsoContext({ quoteEmail = null, idioma = 'pt-BR' }) {
//   return {
//     type: '@param/SSO_CONTEXT',
//     payload: { quoteEmail, idioma },
//   };
// }

export function globParamSuccess(params) {
  return {
    type: '@param/GLOB_PARAM_SUCCESS',
    payload: { params },
  };
}

export function globParamFailure() {
  return {
    type: '@param/GLOB_PARAM_FAILURE',
  };
}

export function setSsoContext({ quoteEmail = null, idioma = 'pt-BR' }) {
  return {
    type: '@param/SSO_CONTEXT',
    payload: { quoteEmail, idioma },
  };
}

/**
 * Idioma escolhido para visualização do catálogo.
 * idioma = null -> usa o comportamento padrão (não envia idioma à API).
 * idioma = '0'..'6' (opIdiomaCatalogo) -> consulta no idioma escolhido.
 */
export function setIdiomaCatalogo(idioma) {
  return {
    type: '@param/IDIOMA_CATALOGO',
    payload: { idioma },
  };
}
